/**
 * 系统管理  公司管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>短信管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item v-if="user.username == 'admin'">
        <el-select v-model="formInline.depId" placeholder="请选择部门" size="small">
           <el-option
             v-for="item in deptData"
             :key="item.id"
             :label="item.departmentName"
             :value="item.id">
           </el-option>
         </el-select>
      </el-form-item>
      <el-form-item label="搜索">
        <el-input size="small" v-model="formInline.meterInfoName" placeholder="请输入表名称"></el-input>
      </el-form-item>
      <el-form-item >
        <el-input size="small" v-model="formInline.phone" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item >
        <el-input size="small" v-model="formInline.content" placeholder="请输入短信内容"></el-input>
      </el-form-item>
      <el-form-item>

        <el-button size="small" type="primary"  @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="dataList" highlight-current-row v-loading="loading" :header-cell-style="this.$store.state.headerCss" :max-height="tableHeight" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>

      <el-table-column  prop="meterInfoName" label="表名称">
      </el-table-column>
      <el-table-column  prop="phone" label="手机号" width="120" >
      </el-table-column>

      <el-table-column  prop="title" label="标题">
      </el-table-column>
      <el-table-column  prop="content" label="内容">
      </el-table-column>
      <el-table-column  prop="contentLength" label="内容字数" width="120">
      </el-table-column>
      <el-table-column  prop="createDate" label="创建时间">
      </el-table-column>
     <!-- <el-table-column align="center" label="操作" width="160" >
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteInfo(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="formInline"  v-if="showPage" @callFather="callFather"></Pagination>

  </div>
</template>

<script>
import { deptList,getMsgDetailList} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      deptData:[],
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      user:{},
      dataList:[],
      // rules表单验证
      rules: {
        depId: [
          { required: true, message: '请选择部门', trigger: 'change' }
        ],
      },
      showPage:true,
       tableHeight:0,
      departmentId:'',
      editForm:{},

      // 查询参数
      formInline: {
        meterInfoName:"",
        content:"",
        phone:"",
        depId:"",
        currentPage: 1,
        pageSize: 10,
        total:0
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.user = JSON.parse(sessionStorage.getItem('userdata'))
    this.getDeptDataList()
    if(this.user.username == 'admin'){

      this.formInline.depId = this.user.departmentId
    }
    this.getData()
  },
  mounted(){
    this.$nextTick(() => {

    	this.tableHeight = window.innerHeight - 300
    })
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    getData(){
      this.loading = true
      getMsgDetailList(this.formInline).then(res => {
        this.loading = false
        if(res.status == 1){
          this.dataList = res.data.data
          this.formInline.total = res.data.totalCount
        }else{
          this.$message.error(res.msg)
        }
      })
    },

    getDeptDataList:function(){
    	deptList().then(res => {
    		if(res.status == 1){
    			this.deptData = res.data
    		}else{
    			this.$message.error(res.msg)
    		}
    	})
    },


    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.currentPage = parm.pageSize

    },
    // 搜索事件
    search() {
      this.showPage = false
      this.getData()
      this.$nextTick(() => {
      	this.showPage = true
      })
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.id = row.id
        this.editForm.depId = row.depId
        this.editForm.appId = row.appId
        this.editForm.appSecret = row.appSecret
        this.editForm.token = row.token
        this.editForm.mchId = row.mchId
        this.editForm.apiKey = row.apiKey
        this.editForm.signType = row.signType
        this.editForm.certPath = row.certPath


      } else {
        this.title = '添加'
      this.editForm.id = ""
      this.editForm.depId = ""
      this.editForm.appId = ""
      this.editForm.appSecret = ""
      this.editForm.token = ""
      this.editForm.mchId = ""
      this.editForm.apiKey = ""
      this.editForm.signType = ""
      this.editForm.certPath = ""
      }
    },

    deleteInfo(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteWxInfo({wxInfoId:row.id})
            .then(res => {
              if(res.status == 1){
                this.$message.success('删除成功')
                this.getData()
              }else{
                this.$message.error(res.msg)
              }
            })

        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>

.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/prepayment/Msg.vue